import { getSettings } from "src/settings";

/**
 * Get the nonce from the meta tag which is set by the vite build process and
 * then replaced by NGINX with a random value.
 * @returns The nonce from the meta tag.
 */
export function getNonceFromMetatag() {
	const metaTag = document.querySelector('meta[property="csp-nonce"]');
	return metaTag?.getAttribute("nonce") ?? undefined;
}

const nonceString = getNonceFromMetatag()
	? `'nonce-${getNonceFromMetatag()}'`
	: "";

export const cspConfig = {
	"default-src": [
		"'self'",
		"https://static.zdassets.com",
		"https://*.zendesk.com",
		"https://ekr.zdassets.com",
		"https://ekr.zendesk.com",
		"https://api.smooch.io",
		"https://media.smooch.io",
		"https://zendesk-eu.my.sentry.io",
		"https://*.twilio.com",
		"wss://*.zendesk.com",
		"wss://api.smooch.io",
		"wss://voice-js.roaming.twilio.com",
		nonceString,
	],
	"script-src": [
		"'self'",
		"https://*.parcellab.com",
		"https://*.tiny.cloud",
		"https://*.tinymce.com",
		"https://*.userpilot.io",
		"https://parcellab.matomo.cloud",
		"https://static.zdassets.com",
		"https://*.zendesk.com",
		"https://ekr.zdassets.com",
		"https://ekr.zendesk.com",
		"https://api.smooch.io",
		"https://media.smooch.io",
		"https://zendesk-eu.my.sentry.io",
		"https://*.twilio.com",
		"wss://*.zendesk.com",
		"wss://api.smooch.io",
		"wss://voice-js.roaming.twilio.com",
		"https://*.hotjar.com",
		nonceString,
	],
	"worker-src": ["'self'", "blob:", nonceString],
	"style-src": [
		"'self'",
		"'unsafe-inline'",
		"https://*.tiny.cloud",
		"https://*.tinymce.com",
		"https://*.parcellab.com",
		"https://*.hotjar.com",
	],
	"img-src": [
		"*",
		"'self'",
		"blob:",
		"data:",
		"https://*.tiny.cloud",
		"https://*.tinymce.com",
		"https://static.zdassets.com",
		"https://*.parcellab.com",
		"https://accounts.zendesk.com",
		"https://*.zendesk.com",
		"https://media.smooch.io",
		"https://*.zdusercontent.com",
		"https://*.hotjar.com",
		getSettings().cdn.URL,
		getSettings().cdn.ProductApiURL,
		nonceString,
	],
	"font-src": [
		"'self'",
		"https://*.tiny.cloud",
		"https://*.tinymce.com",
		"https://*.parcellab.com",
		"https://*.hotjar.com",
		nonceString,
	],
	"frame-src": [
		"'self'",
		getSettings().productApi.CUSTOMER_SERVICE_URL,
		"https://app.powerbi.com",
		"https://metabase.parcellab.dev",
		"*.hotjar.com",
		"https://crowdin.com",
		"https://*.parcellab.com",
		nonceString,
		"https://app.storylane.io",
	],
	"connect-src": [
		"'self'",
		getSettings().productApi.URL,
		getSettings().backendApi.URL,
		getSettings().copilotApi.URL,
		"https://returns-api.parcellab.com",
		"https://oauth.staging.parcellab.dev",
		"https://auth.parcellab.com",
		"https://auth.staging.parcellab.dev",
		"https://parcellab.matomo.cloud",
		"https://parcellabhelp.zendesk.com",
		"https://*.tiny.cloud",
		"https://*.tinymce.com",
		"https://sentry.parcellab.com",
		"https://*.parcellab.com",
		"https://*.userpilot.io",
		"wss://*.userpilot.io",
		"https://*.zendesk.com",
		"wss://*.zendesk.com",
		"https://static.zdassets.com",
		"https://*.zendesk.com",
		"https://ekr.zdassets.com",
		"https://ekr.zendesk.com",
		"https://api.smooch.io",
		"https://media.smooch.io",
		"https://zendesk-eu.my.sentry.io",
		"https://*.twilio.com",
		"wss://*.zendesk.com",
		"wss://api.smooch.io",
		"wss://voice-js.roaming.twilio.com",
		"https://statuspal.io",
		"https://*.hotjar.com",
		"https://*.hotjar.io",
		"wss://*.hotjar.com",
		"https://oauth.parcellab.dev",
		"https://oauth.parcellab.com",
		nonceString,
	],
	"object-src": ["'none'"],
	"media-src": ["'self'", "https://static.zdassets.com"],
};
